exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-size-small {\n    height: 0.5em !important;\n}\n\n.visibility-hidden {\n    visibility: hidden;\n}\n\n.forgot-password-link {\n    position: relative;\n    line-height: 36px;\n    font-size: 14px;\n    float: right;\n    top: -5px;\n}\n\n.popular-repo-wrapper {\n    background-color: white;\n    min-height: 100vh;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    margin-top: 24px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    height: auto;\n    position: relative;\n    margin-left: 1px;\n}\n\n.login-wrapper-override {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n\n.repo-container {\n    width: 100%;\n    margin-top: -250px;\n}\n\n.more-info-link {\n    position: relative;\n    top: 80px;\n    left: 294px;\n    padding-right: 36px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/account/sign-in/sign-in.component.css
// module id = 810
// module chunks = 0